import Counter from "../Counter.jsx";

export default ({
                    i,
                    value,
                    label,
                    setHoveredIndex,
                    baseColor,
                    lightColor,
                    percent,
                    isHovered,
                    isChartHovered,
                    onClick,
                }) => {
    return (
        <div
            className={`legend-item flex-vertical-center ${isChartHovered && !isHovered ? 'is-faded' : ''}`}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={onClick}
            style={{
                "--baseColor": baseColor,
                "--lightColor": lightColor,
            }}
        >
            <div className='label-color'/>
            <div className='label-pct'>
                <Counter
                    amount={percent*100}
                    suffix={'%'}
                />
            </div>
            <div className='label-text'>
                {label}
            </div>
        </div>
    )
}